<template>
  <section class="hero-section">
    <div class="hero-section__bg" />

    <div class="hero-section__content">
      <div
        class="hero-section__title-block reveal-child"
        :style="{ transitionDelay: visible ? '0.1s' : '0s' }"
      >
        <h1 class="hero-section__title">中国民族工商文化特色资源库</h1>
        <p class="hero-section__subtitle">ZHONG GUO GONG SHANG WEN HUA TE SE ZI YUAN KU</p>
      </div>

      <div
        class="hero-section__search reveal-child"
        :style="{ transitionDelay: visible ? '0.25s' : '0s' }"
      >
        <div class="hero-section__search-bar">
          <el-select v-model="searchType" class="hero-section__search-select" popper-class="hero-select-popper">
            <el-option label="全部" value="all" />
            <el-option label="史料知识" value="knowledge" />
            <el-option label="馆藏资源" value="resources" />
            <el-option label="主题展览" value="exhibition" />
          </el-select>
          <input
            v-model="keyword"
            type="text"
            class="hero-section__search-input"
            placeholder="请输入您要查找的人和事（内部档案/公开史料/研究论述/人物/机构/地点/事件等）"
          />
          <button type="button" class="hero-section__search-btn" @click="handleSearch">
            <i class="el-icon-search" />
            <span>从资料库查找</span>
          </button>
        </div>
      </div>

      <div class="hero-section__main">
        <div
          class="hero-section__gallery reveal-child"
          :style="{ transitionDelay: visible ? '0.4s' : '0s' }"
        >
          <div class="hero-section__gallery-bg">
            <img
              src="@/assets/pic2.png"
              alt="历史工厂"
            />
          </div>
        </div>

        <div
          class="hero-section__info reveal-child"
          :style="{ transitionDelay: visible ? '0.55s' : '0s' }"
        >
          <p class="hero-section__info-label">已收录资料</p>
          <p class="hero-section__info-count">{{ entityCountText }}</p>
          <div class="hero-section__info-text">
            <p>中国民族工商文化特色资源库，旨在系统收集、整理和研究中国近现代民族工商业发展历史与文化。</p>
            <p>资源库涵盖人物传记、企业档案、历史事件、研究论述等多类型文献资料，为学术研究与文化传承提供支撑。</p>
            <p>依托江南大学学术力量，致力于构建国内领先的民族工商文化数字资源平台。</p>
          </div>
          <div class="hero-section__info-image">
            <!-- <img
              src="https://images.unsplash.com/photo-1581091226033-d5ecf481604c?w=400&h=200&fit=crop&grayscale"
              alt="1860-1956"
            />
            <span class="hero-section__info-year">1860-1956</span> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { navigateBySearchScope } from '@/utils/searchNavigation'
import { fetchEntityCount } from '@/api/home'

export default {
  name: 'HeroSection',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchType: 'all',
      keyword: '',
      entityCount: null,
      galleryPhotos: [
        {
          src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=250&fit=crop&grayscale',
          alt: '历史人物',
          style: { top: '8%', left: '5%', transform: 'rotate(-8deg)', width: '28%' }
        },
        {
          src: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=200&h=250&fit=crop&grayscale',
          alt: '历史建筑',
          style: { top: '15%', right: '8%', transform: 'rotate(6deg)', width: '30%' }
        },
        {
          src: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=200&h=250&fit=crop&grayscale',
          alt: '工厂设备',
          style: { bottom: '12%', left: '12%', transform: 'rotate(4deg)', width: '26%' }
        },
        {
          src: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=200&h=250&fit=crop&grayscale',
          alt: '城市风貌',
          style: { bottom: '8%', right: '5%', transform: 'rotate(-5deg)', width: '32%' }
        }
      ]
    }
  },
  computed: {
    entityCountText() {
      if (this.entityCount == null) {
        return '--'
      }
      return Number(this.entityCount).toLocaleString('zh-CN')
    }
  },
  mounted() {
    this.loadEntityCount()
  },
  methods: {
    async loadEntityCount() {
      try {
        const data = await fetchEntityCount()
        this.entityCount = data && data.total != null ? Number(data.total) : 0
      } catch (error) {
        this.entityCount = 0
      }
    },
    handleSearch() {
      const trimmed = (this.keyword || '').trim()
      if (!trimmed) {
        this.$message.warning('请输入搜索关键词')
        return
      }
      navigateBySearchScope(this.$router, this.searchType, trimmed)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero-section {
  position: relative;
  min-height: 100vh;
  padding-top: $header-height;

  &__bg {
    position: absolute;
    inset: 0;
    background:
      url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E"),
      linear-gradient(180deg, $color-paper-light 0%, $color-paper 20%, $color-paper-dark 100%);
    z-index: 0;
  }

  &__content {
    position: relative;
    z-index: 1;
    @include page-container;
    padding-top: $spacing-3xl;
    padding-bottom: $spacing-4xl;
  }

  &__title-block {
    text-align: center;
    margin-bottom: $spacing-2xl;
  }

  &__title {
    font-family: $font-serif;
    font-size: clamp(#{rem(28)}, 4vw, #{rem(48)});
    font-weight: 700;
    color: $color-brown-dark;
    letter-spacing: 4px;
    line-height: 1.3;
  }

  &__subtitle {
    margin-top: $spacing-md;
    font-size: clamp(#{rem(10)}, 1.2vw, #{rem(14)});
    letter-spacing: 4px;
    color: $color-text-light;
  }

  &__search {
    margin-bottom: $spacing-3xl;
  }

  &__search-bar {
    display: flex;
    align-items: stretch;
    max-width: rem(960);
    width: 100%;
    margin: 0 auto;
    background: $color-white;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 4px 24px rgba($color-brown-dark, 0.12);
  }

  &__search-select {
    width: rem(100);
    flex-shrink: 0;

    ::v-deep .el-input__inner {
      box-shadow: none;
      border-radius: 0;
      height: rem(52);
      border: none;
    }
  }

  &__search-input {
    flex: 1;
    padding: 0 $spacing-base;
    border: none;
    font-size: rem(14);
    color: $color-text;
    min-width: 0;

    &::placeholder {
      color: #aaa;
      font-size: rem(13);
    }
  }

  &__search-btn {
    display: flex;
    align-items: center;
    gap: $spacing-sm;
    padding: 0 $spacing-xl;
    background: $success-color;
    color: $color-white;
    font-size: rem(14);
    white-space: nowrap;
    transition: background 0.2s;
    flex-shrink: 0;

    &:hover {
      background: $color-green-light;
    }
  }

  &__main {
    display: flex;
    gap: $spacing-xl;
    align-items: stretch;
    width: 100%;
    min-width: 0;
  }

  &__gallery {
    flex: 1;
    position: relative;
    min-height: rem(420);
    min-width: 0;
    border-radius: 4px;
    overflow: hidden;
  }

  &__gallery-bg {
    position: absolute;
    inset: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: sepia(0.4) brightness(0.85);
    }
  }

  &__gallery-photos {
    position: absolute;
    inset: 0;
    padding: $spacing-base;
  }

  &__photo {
    position: absolute;
    background: $color-white;
    padding: $spacing-xs;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);

    img {
      width: 100%;
      aspect-ratio: 3/4;
      object-fit: cover;
    }
  }

  &__info {
    width: rem(320);
    max-width: 100%;
    flex-shrink: 0;
    background: rgba($color-cream, 0.95);
    padding: $spacing-xl;
    box-shadow: 0 8px 32px rgba($color-brown-dark, 0.1);
    display: flex;
    flex-direction: column;
  }

  &__info-label {
    font-size: rem(13);
    color: $color-text-light;
    margin-bottom: $spacing-sm;
  }

  &__info-count {
    font-family: $font-serif;
    font-size: rem(36);
    font-weight: 700;
    color: $color-brown-dark;
    letter-spacing: 1px;
    margin-bottom: $spacing-base;
  }

  &__info-text {
    flex: 1;
    font-size: rem(13);
    line-height: 1.8;
    color: $color-text-light;

    p + p {
      margin-top: $spacing-md;
    }
  }

  &__info-image {
    position: relative;
    margin-top: $spacing-base;
    border-radius: 2px;
    overflow: hidden;
    height: rem(120);

    img {
      width: 100%;
      height: rem(120);
      object-fit: cover;
      filter: grayscale(1);
    }
  }

  &__info-year {
    position: absolute;
    bottom: $spacing-sm;
    left: $spacing-sm;
    font-size: rem(12);
    color: $color-white;
    background: rgba(0, 0, 0, 0.5);
    padding: 2px $spacing-sm;
  }
}

@media (max-width: 960px) {
  .hero-section {
    &__main {
      flex-direction: column;
    }

    &__info {
      width: 100%;
    }

    &__search-bar {
      flex-direction: column;
    }

    &__search-select {
      width: 100%;
    }

    &__search-btn {
      justify-content: center;
      padding: $spacing-base;
    }
  }
}
</style>
